/**
 * Doctor Templates API Service
 * 
 * Serviciu pentru gestionarea template-urilor personale ale medicilor
 */

import apiClient from './api';

export interface DoctorTemplate {
  id: string;
  tenant_id: string;
  doctor_id: string;
  name: string;
  content_html: string;
  content_json: any;
  is_favorite: boolean;
  usage_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateTemplateRequest {
  name: string;
  content_html: string;
  content_json: any;
  is_favorite?: boolean;
}

export interface UpdateTemplateRequest {
  name?: string;
  content_html?: string;
  content_json?: any;
  is_favorite?: boolean;
}

export interface QuickSaveRequest {
  name: string;
  content_html: string;
  content_json: any;
  is_favorite?: boolean;
}

export const doctorTemplatesApi = {
  /**
   * Obține toate template-urile proprii
   */
  getTemplates: async (params?: { search?: string; favoritesOnly?: boolean }): Promise<DoctorTemplate[]> => {
    const queryParams = new URLSearchParams();
    if (params?.search) queryParams.append('search', params.search);
    if (params?.favoritesOnly) queryParams.append('favoritesOnly', 'true');
    
    const url = `/doctor-templates/${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    const response = await apiClient.get<DoctorTemplate[]>(url);
    return response.data;
  },

  /**
   * Obține un template specific
   */
  getTemplate: async (id: string): Promise<DoctorTemplate> => {
    const response = await apiClient.get<DoctorTemplate>(`/doctor-templates/${id}`);
    return response.data;
  },

  /**
   * Creează un template nou
   */
  createTemplate: async (data: CreateTemplateRequest): Promise<DoctorTemplate> => {
    const response = await apiClient.post<DoctorTemplate>('/doctor-templates/', data);
    return response.data;
  },

  /**
   * Actualizează un template
   */
  updateTemplate: async (id: string, data: UpdateTemplateRequest): Promise<DoctorTemplate> => {
    const response = await apiClient.patch<DoctorTemplate>(`/doctor-templates/${id}`, data);
    return response.data;
  },

  /**
   * Șterge un template
   */
  deleteTemplate: async (id: string): Promise<void> => {
    await apiClient.delete(`/doctor-templates/${id}`);
  },

  /**
   * Toggle favorite status
   */
  toggleFavorite: async (id: string): Promise<DoctorTemplate> => {
    const response = await apiClient.post<DoctorTemplate>(`/doctor-templates/${id}/favorite`);
    return response.data;
  },

  /**
   * Incrementează usage count (când template-ul este aplicat)
   */
  incrementUsage: async (id: string): Promise<DoctorTemplate> => {
    const response = await apiClient.post<DoctorTemplate>(`/doctor-templates/${id}/use`);
    return response.data;
  },

  /**
   * Quick save - salvează conținutul curent ca template nou
   */
  quickSave: async (data: QuickSaveRequest): Promise<DoctorTemplate> => {
    const response = await apiClient.post<DoctorTemplate>('/doctor-templates/from-content', data);
    return response.data;
  }
};

export default doctorTemplatesApi;

